import { useState, useEffect } from 'react';
import { fetchCountryCodes } from '../api/api';

export const useCountryCodes = () => {
    const [countryCodes, setCountryCodes] = useState([{ code: '+44', country: 'GB' }]);
    const [isLoadingCountryCodes, setIsLoadingCountryCodes] = useState(true);
    const [searchCountryCode, setSearchCountryCode] = useState('');
    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [totalQuotes, setTotalQuotes] = useState(0);

    // Fetch country codes from API
    useEffect(() => {
        loadCountryCodes();
    }, []);

    const loadCountryCodes = async () => {
        try {
            setIsLoadingCountryCodes(true);
            const codes = await fetchCountryCodes();
            setCountryCodes(codes.countries);
            setTotalQuotes(codes.totalQuotes);
        } catch (error) {
            console.error('Failed to load country codes:', error);
        } finally {
            setIsLoadingCountryCodes(false);
        }
    };

    // Filtered country codes based on search
    const filteredCountryCodes = countryCodes.filter(
        country =>
            country.code.toLowerCase().includes(searchCountryCode.toLowerCase()) || 
            country.country.toLowerCase().includes(searchCountryCode.toLowerCase())
    );

    // Handle country code selection
    const handleCountryCodeSelect = (code, onCodeChange) => {
        onCodeChange('countryCode', code);
        setSearchCountryCode('');
        setShowCountryDropdown(false);
    };

    // Handle search input change
    const handleCountrySearchChange = (value) => {
        setSearchCountryCode(value);
        setShowCountryDropdown(true);
    };

    // Handle keyboard navigation
    const handleCountryCodeKeyDown = (e, onCodeChange) => {
        if (e.key === 'Enter' && filteredCountryCodes.length > 0) {
            handleCountryCodeSelect(filteredCountryCodes[0].code, onCodeChange);
        } else if (e.key === 'Escape') {
            setShowCountryDropdown(false);
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.countryCodeContainer')) {
                setShowCountryDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return {
        countryCodes,
        isLoadingCountryCodes,
        searchCountryCode,
        showCountryDropdown,
        filteredCountryCodes,
        totalQuotes,
        setShowCountryDropdown,
        handleCountryCodeSelect,
        handleCountrySearchChange,
        handleCountryCodeKeyDown,
    };
};
